// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lobby-bar {
  background-color: var(--keywords-bgr);
  padding: 0;
}

.icon-spacing {
  padding-right: 0.5rem;
  padding-left: 0.25rem;
  color: white;
  display: flex;
}
.icon-spacing ::ng-deep ion-icon {
  min-width: 15px !important;
  height: 15px !important;
  max-width: 17px !important;
  transform: unset !important;
  padding: 0 !important;
}
.icon-spacing.favorite ::ng-deep ion-icon {
  height: 17px !important;
  max-width: 18px !important;
}

.keywords-isactive .icon-spacing {
  color: var(--keywords-bgr);
}
.keywords-isactive .icon-spacing.favorite {
  color: var(--fav-icon-color);
}

.mobile-search-container {
  background-color: var(--ion-color-secondary);
  padding: 2px;
}

.heart-icon {
  --icon-height: 1.5rem;
  --icon-width: 1.5rem;
  padding-right: 0.5rem;
  padding-left: 0.25rem;
}

ion-label {
  text-transform: none;
}

.scroll-left-button {
  z-index: 2;
}

.icons {
  z-index: 1;
}

.lobby-category-icon svg {
  --icon-color: red;
}

p {
  text-transform: lowercase;
}

p:first-letter {
  text-transform: uppercase;
}

@media screen and (max-width: 1800px) {
  .menu-items {
    max-width: 90vw !important;
  }
}
@media screen and (max-width: 1570px) {
  .menu-items {
    max-width: 89vw !important;
  }
}
@media screen and (max-width: 1450px) {
  .menu-items {
    max-width: 88vw !important;
  }
}
@media screen and (max-width: 1330px) {
  .menu-items {
    max-width: 87vw !important;
  }
}
@media screen and (max-width: 1220px) {
  .menu-items {
    max-width: 86vw !important;
  }
}

ion-label[font*=secondary] {
  font-family: var(--font-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/casino-lobby/keywords-casino/lobby-verticals.component.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,UAAA;AACF;;AAEA;EACE,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;AACF;AAEE;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,qBAAA;AAAJ;AAGI;EACE,uBAAA;EACA,0BAAA;AADN;;AAOE;EACE,0BAAA;AAJJ;AAMI;EACE,4BAAA;AAJN;;AASA;EACE,4CAAA;EACA,YAAA;AANF;;AASA;EACE,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;AANF;;AASA;EACE,oBAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,UAAA;AANF;;AAUE;EAEE,iBAAA;AARJ;;AAYA;EACE,yBAAA;AATF;;AAYA;EACE,yBAAA;AATF;;AAaE;EADF;IAEI,0BAAA;EATF;AACF;AAWE;EALF;IAMI,0BAAA;EARF;AACF;AAUE;EATF;IAUI,0BAAA;EAPF;AACF;AASE;EAbF;IAcI,0BAAA;EANF;AACF;AAQE;EAjBF;IAkBI,0BAAA;EALF;AACF;;AASE;EACE,kCAAA;AANJ","sourcesContent":[".lobby-bar {\n  background-color: var(--keywords-bgr);\n  padding: 0;\n}\n\n.icon-spacing {\n  padding-right: .5rem;\n  padding-left: .25rem;\n  color: white;\n  display: flex;\n\n\n  ::ng-deep ion-icon {\n    min-width: 15px !important;\n    height: 15px !important;\n    max-width: 17px !important;\n    transform: unset !important;\n    padding: 0 !important;\n  }\n  &.favorite {\n    ::ng-deep ion-icon {\n      height: 17px !important;\n      max-width: 18px !important;\n    }\n  }\n}\n\n.keywords-isactive {\n  .icon-spacing {\n    color: var(--keywords-bgr);\n\n    &.favorite {\n      color: var(--fav-icon-color);\n    }\n  }\n}\n\n.mobile-search-container {\n  background-color: var(--ion-color-secondary);\n  padding: 2px;\n}\n\n.heart-icon {\n  --icon-height: 1.5rem;\n  --icon-width: 1.5rem;\n  padding-right: .5rem;\n  padding-left: .25rem;\n}\n\nion-label {\n  text-transform: none;\n}\n\n.scroll-left-button {\n  z-index: 2;\n}\n\n.icons {\n  z-index: 1;\n}\n\n.lobby-category-icon {\n  svg {\n    // var(--link-color)\n    --icon-color: red;\n  }\n}\n\np {\n  text-transform: lowercase;\n}\n\np:first-letter {\n  text-transform: uppercase;\n}\n\n.menu-items {\n  @media screen and (max-width: 1800px) {\n    max-width: 90vw !important;\n  }\n\n  @media screen and (max-width: 1570px) {\n    max-width: 89vw !important;\n  }\n\n  @media screen and (max-width: 1450px) {\n    max-width: 88vw !important;\n  }\n\n  @media screen and (max-width: 1330px) {\n    max-width: 87vw !important;\n  }\n\n  @media screen and (max-width: 1220px) {\n    max-width: 86vw !important;\n  }\n}\n\nion-label {\n  &[font*='secondary'] {\n    font-family: var(--font-secondary);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
